import type { FC } from 'react'
import React from 'react'
import { useErrorHandling } from '@/tools/o11y/client'
import { ListItem, ListItemBody } from '@/tools/ui'
import type { GoogleAddressCompact } from '@/user/address-book/entities'

interface Props {
  onClick: (placeId: string) => void
  address: GoogleAddressCompact
  isLastItem?: boolean
}
export const AddressSearchItem: FC<Props> = ({ onClick, address, isLastItem }) => {
  const { withErrorTracking } = useErrorHandling()

  const handleOnClick = withErrorTracking(() => {
    onClick(address.placeId)
  })

  return (
    <ListItem actionable={true} withDivider={!isLastItem} onClick={handleOnClick}>
      <ListItemBody description={address.subtitle} title={address.title} />
    </ListItem>
  )
}
